import commitMutation from 'relay-commit-mutation-promise';
import {
    IEnvironment,
    OperationType,
    GraphQLTaggedNode,
    SelectorStoreUpdater,
} from 'relay-runtime';

const loader = (name: string): Promise<{ mutation: GraphQLTaggedNode }> => {
    switch (name) {
        case 'ReportCheckoutMutation':
            return import(
                './ReportCheckoutMutation' /* webpackChunkName: "ReportCheckoutMutation" */
            );
        case 'UserRegisterAndAddAddressMutation':
            return import(
                './UserRegisterAndAddAddressMutation' /* webpackChunkName: "UserRegisterAndAddAddressMutation" */
            );
        case 'UserAddAddressMutation':
            return import(
                './UserAddAddressMutation' /* webpackChunkName: "UserAddAddressMutation" */
            );
        case 'UserEditAddressMutation':
            return import(
                './UserEditAddressMutation' /* webpackChunkName: "UserEditAddressMutation" */
            );
        case 'UserDeleteAddressMutation':
            return import(
                './UserDeleteAddressMutation' /* webpackChunkName: "UserDeleteAddressMutation" */
            );
        case 'UserVaultPaymentMethodMutation':
            return import(
                './UserVaultPaymentMethodMutation' /* webpackChunkName: "UserVaultPaymentMethodMutation" */
            );
        case 'UserDeletePaymentMethodMutation':
            return import(
                './UserDeletePaymentMethodMutation' /* webpackChunkName: "UserDeletePaymentMethodMutation" */
            );
        case 'TransactionCheckout':
            return import(
                './TransactionCheckoutMutation' /* webpackChunkName: "TransactionCheckoutMutation", webpackPrefetch: true */
            );
        case 'TransactionMultiStageCheckout':
            return import(
                './TransactionMultiStageCheckoutMutation' /* webpackChunkName: "TransactionMultiStageCheckoutMutation", webpackPrefetch: true */
            );
        case 'TransactionUpdateShipment':
            return import(
                './TransactionUpdateShipmentMutation' /* webpackChunkName: "TransactionUpdateShipmentMutation", webpackPrefetch: true */
            );
        case 'TransactionShipmentQuote':
            return import(
                './TransactionShipmentQuoteMutation'
            ); /* webpackChunkName: "TransactionShipmentQuoteMutation", webpackPrefetch: true */
        case 'TransactionShipmentReview':
            return import(
                './TransactionShipmentReviewMutation'
            ); /* webpackChunkName: "TransactionShipmentReviewMutation", webpackPrefetch: true */
        case 'TransactionCheckoutNote':
            return import(
                './TransactionCheckoutNoteMutation'
            ); /* webpackChunkName: "TransactionCheckoutNoteMutation", webpackPrefetch: true */
        case 'TransactionTaxExemptReview':
            return import(
                './TransactionTaxExemptReviewMutation'
            ); /* webpackChunkName: "TransactionTaxExemptReviewMutation", webpackPrefetch: true */
        case 'TransactionCheckoutOffer':
            return import(
                './TransactionCheckoutOfferMutation'
            ); /* webpackChunkName: "TransactionCheckoutOfferMutation", webpackPrefetch: true */
        case 'TransactionCheckoutChangeBuyerChargeCurrencyMutation':
            return import(
                './TransactionCheckoutChangeBuyerChargeCurrencyMutation'
            ); /* webpackChunkName: "TransactionCheckoutChangeBuyerChargeCurrencyMutation", webpackPrefetch: true */
        case 'TransactionTrackCheckoutLoad':
            return import(
                './TransactionTrackCheckoutLoadMutation'
            ); /* webpackChunkName: "TransactionTrackCheckoutLoadMutation", webpackPrefetch: true */
        case 'TransactionCreateStripeSetupIntent':
            return import(
                './TransactionCreateStripeSetupIntentMutation'
            ); /* webpackChunkName: "TransactionCreateStripeSetupIntentMutation", webpackPrefetch: true */
        case 'TransactionSaveStripePaymentMethod':
            return import(
                './TransactionSaveStripePaymentMethodMutation'
            ); /* webpackChunkName: "TransactionSaveStripePaymentMethodMutation", webpackPrefetch: true */
        default:
            return Promise.reject(new Error(`No mutation ${name} found`));
    }
};

function commit<T extends OperationType>(
    mutationName: string,
    environment: IEnvironment,
    input: T['variables']['input'],
    isMobile: boolean,
    updater?: SelectorStoreUpdater<T['response']>
): Promise<T['response']> {
    return loader(mutationName).then(({ mutation }) => {
        return commitMutation(environment, {
            mutation,
            variables: { input, isMobile },
            updater,
        });
    });
}

export default { commit };
